<div class="card">
    <div class="card-header">
      <h4>Customer Transaction Report</h4>
    </div>
    <div class="card-body m-0">
      <div class="row mb-2">
        <div class="col-xl-12">
          <!-- Filter Accordion -->
          <ngb-accordion #acc="ngbAccordion" activeIds="filter-panel">
            <ngb-panel id="filter-panel" title="Filters">
              <ng-template ngbPanelContent>
                <div class="row g-9 mb-8">
                  <!-- Customer Information (Mobile, ID, and Name) -->
                <div class="row mt-4">
                    <div class="col-md-4">
                        <label class="col-form-label" for="customerName">Customer Name</label>
                        <input type="text" class="form-control" id="customerName" placeholder="Please enter Customer Name"
                            [(ngModel)]="customerName" maxlength="50"/>
                    </div>
                    <div class="col-md-4">
                        <label class="col-form-label" for="customerPhone">Customer Mobile Number (Registered)</label>
                        <input type="text" class="form-control" id="customerPhone"
                            placeholder="Please enter Customer Phone" [(ngModel)]="customerMobile" maxlength="10" (keypress)="OnlyNumbersAllowed($event)" />
                    </div>
                    <div class="col-md-4">
                        <label class="col-form-label" for="customerId">Customer ID</label>
                        <!-- <input type="text" class="form-control" id="customerId" placeholder="Please enter Customer ID"
                            [(ngModel)]="customerId" maxlength="8" (keypress)="OnlyNumbersAllowed($event)" /> -->

                            <ng-select id="customerId"  placeholder="Select Customer" [inputAttrs]="{maxlength: '100'}"
                           [(ngModel)]="customerId">
                              <ng-option *ngFor="let customer of customerData" [value]="customer.userId">
                                {{customer.fullName}} ({{customer.userId}})
                              </ng-option>
                            </ng-select>
                    </div>
                </div>

                <!-- Currency and Amount -->
                <div class="row mt-4">
                  <div class="col-md-4">
                  <label class="col-form-label" for="currency">Currency</label>
                  <!-- <ng-select id="currency" placeholder="Select Currency" [inputAttrs]="{maxlength: '100'}"
                      [(ngModel)]="currency">
                  </ng-select> -->
                  <ng-select id="currency"  placeholder="Select Currency" [inputAttrs]="{maxlength: '100'}"
                  [(ngModel)]="currency">
                     <ng-option *ngFor="let currency of currencyrData" [value]="currency">
                       {{currency}}
                     </ng-option>
                   </ng-select>
                  </div>
                    <div class="col-md-4">
                        <label class="col-form-label" for="amount">Amount</label>
                        <input type="text" class="form-control" id="amount" placeholder="Please enter Amount"
                            [(ngModel)]="amount" onkeypress="return event.keyCode === 8 || (event.charCode >= 48 && event.charCode <= 57) || (event.target.value.indexOf('.') < 0 && event.target.value.length>0 && event.charCode === 46)"/>
                    </div>
                    <div class="col-md-4">
                      <label class="col-form-label" for="txnStatus">Transaction Status</label>
                      <ng-select id="txnStatus" placeholder="Select Transaction Status" [inputAttrs]="{maxlength: '100'}"
                          [(ngModel)]="status" [multiple]="true"  [closeOnSelect]="false">
                          <ng-option value="SUCCESS">Success</ng-option>
                                <ng-option value="FAILED">Failed</ng-option>
                                <ng-option value="PENDING">Pending</ng-option>
                                <ng-option value="REQUEST_INITIATED">Request Initiated</ng-option>
                                <ng-option value="REFUNDED">Refund</ng-option>
                      </ng-select>
                  </div>
                </div>

                <!-- Transaction Status, Merchant Information and Date Range -->
                <div class="row mt-4">
                    <div class="col-md-4">
                        <label class="col-form-label" for="merchantId">Merchant Name</label>
                        <input type="text" class="form-control" id="merchantName" placeholder="Please enter Merchant Name"
                            [(ngModel)]="merchantName" />
                    </div>
                    <!-- <div class="col-md-4">
                        <label class="col-form-label">Merchant UUID
                          </label>
                        <ng-select id="merchant"  placeholder="Select Merchant" [inputAttrs]="{maxlength: '100'}"
                        [(ngModel)]="merchant" >
                          <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.userId">
                            {{merchant.fullName}} ({{merchant.userId}})
                          </ng-option>
                        </ng-select>

                        <div *ngIf="!mindatadis" class="text-danger mt-1">
                         No Report Found !
                        </div>
                    </div> -->
                    <div class="col-md-4">
                        <label class="col-form-label" for="merchantId">Merchant ID</label>
                        <input type="text" class="form-control" id="merchantId" placeholder="Please enter Merchant ID"
                            [(ngModel)]="merchantId" />
                    </div>

                    <div class="col-md-4">
                      <label class="col-form-label" for="txnStatus">Channel</label>
                      <ng-select id="txnStatus" placeholder="Select Channel" [inputAttrs]="{maxlength: '100'}"
                          [(ngModel)]="channel" [multiple]="true"  [closeOnSelect]="false">
                                <ng-option value="QR">QR</ng-option>
                                <ng-option value="P2P">P2P</ng-option>
                                <ng-option value="FATOURATI">Fatourati</ng-option>
                                <ng-option value="MAZMA">Mazma</ng-option>
                                <ng-option value="BANK TRANSFER">Bank Transfer</ng-option>
                                <ng-option value="SWAM">SWAM</ng-option>
                                <ng-option value="CNSS">CNSS</ng-option>
                                <ng-option value="WAFR">Wafr</ng-option>
                      </ng-select>
                  </div>
                </div>

                <!-- Date Range (From and To) -->
                <div class="row mt-4">
                    <div class="col-md-4">
                        <label class="col-form-label" style="display: block;padding-bottom: 0;">Date From</label>
                        <input type="datetime-local" [(ngModel)]="searchFromDateTime" class="form-control" id="searchFromDate"
                             />
                    </div>
                    <div class="col-md-4">
                        <label class="col-form-label" style="display: block;padding-bottom: 0;">Date To</label>
                        <input type="datetime-local" [(ngModel)]="searchToDateTime" class="form-control" id="searchToDate"
                            />
                    </div>
                    <div class="col-md-4">
                      <label class="col-form-label" for="txnStatus">Category</label>
                      <ng-select id="txnStatus" placeholder="Select Category" [inputAttrs]="{maxlength: '100'}"
                          [(ngModel)]="category" [multiple]="true"  [closeOnSelect]="false">
                                <ng-option value="TOPUP">Top-up</ng-option>
                                <ng-option value="WITHDRAWAL">Withdrawal</ng-option>
                                <ng-option value="P2P">P2P</ng-option>
                                <ng-option value="P2M">P2M</ng-option>
                                <ng-option value="FATOURATI">Fatourati</ng-option>
                                <ng-option value="MAZMA">Mazma</ng-option>
                                <ng-option value="CNSS">CNSS</ng-option>
                                <ng-option value="WAFR">Wafr</ng-option>
                                <ng-option value="IBAN_TRANSAFER">IBAN Transfer</ng-option>
                      </ng-select>
                  </div>

                </div>

                <!-- column name, logical condition and search text -->

                <div class="row mt-4">
                  <div class="col-md-4">
                    <label class="col-form-label" for="columnName">Column Name</label>
                    <ng-select id="columnName" placeholder="Select Column Name" [inputAttrs]="{maxlength: '100'}"
                      [(ngModel)]="columnnName" (ngModelChange)="onColumnNameChange()">
                      <ng-option value="">Please select</ng-option>
                      <!-- <ng-option value="channel" [disabled]="getDisabledColumns().includes('channel')">Channel</ng-option> -->
                      <ng-option value="productCode" [disabled]="getDisabledColumns().includes('productCode')">Product Id</ng-option>
                      <!-- <ng-option value="category" [disabled]="getDisabledColumns().includes('category')">Category</ng-option> -->
                      <ng-option value="txnId" [disabled]="getDisabledColumns().includes('txnId')">Order ID</ng-option>
                      <ng-option value="STATUS" [disabled]="getDisabledColumns().includes('status')">Status</ng-option>
                      <ng-option value="appVersion" [disabled]="getDisabledColumns().includes('appVersion')">App Version</ng-option>
                      <ng-option value="bankReferenceNumber" [disabled]="getDisabledColumns().includes('bankReferenceNumber')">Bank Reference Number</ng-option>
                      <ng-option value="deviceId" [disabled]="getDisabledColumns().includes('deviceId')">Device ID</ng-option>
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label class="col-form-label" for="logicalCondition">Logical Condition</label>
                    <ng-select id="logicalCondition" placeholder="Select Logical Condition"
                      [inputAttrs]="{maxlength: '100'}" [(ngModel)]="logicalCondition" [disabled]="!columnnName">
                      <ng-container *ngIf="columnnName === 'appVersion'">
                        <ng-option value="EqualsTo">Equals to</ng-option>
                        <ng-option value="NotEqualsTo">Not Equals to</ng-option>
                        <ng-option value="GreaterThanEqualTo">Greater than equal to</ng-option>
                        <ng-option value="LessThanEqualTo">Less than equal to</ng-option>
                        <ng-option value="GreaterThan">Greater than</ng-option>
                        <ng-option value="LessThan">Less than</ng-option>
                      </ng-container>
                      <ng-container *ngIf="columnnName !== 'appVersion'">
                        <ng-option value="EqualsTo">Equals to</ng-option>
                        <ng-option value="NotEqualsTo">Not Equals to</ng-option>
                      </ng-container>
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label class="col-form-label" for="searchText">Search Text</label>
                    <input *ngIf="columnnName !== 'STATUS' && columnnName !== 'status'" type="text" class="form-control" id="searchText" placeholder="Please enter search text"
                      [(ngModel)]="searchText" [disabled]="!columnnName" />
                    <ng-select *ngIf="columnnName === 'STATUS' || columnnName === 'status'" id="searchText" placeholder="Select Status"
                      [(ngModel)]="searchText" [disabled]="!columnnName">
                      <ng-option *ngFor="let status of statusFilterOptions" [value]="status.value">
                        {{status.label}}
                      </ng-option>
                    </ng-select>
                  </div>
                </div>

                <div class="row mt-4">
                  <div class="col-md-4">
                    <label class="col-form-label" for="columnName1">Column Name</label>
                    <ng-select id="columnName1" placeholder="Select Column Name" [inputAttrs]="{maxlength: '100'}"
                      [(ngModel)]="columnnName1" (ngModelChange)="onColumnNameChange1()">
                      <ng-option value="">Please select</ng-option>
                      <!-- <ng-option value="channel" [disabled]="getDisabledColumns().includes('channel')">Channel</ng-option> -->
                      <ng-option value="productCode" [disabled]="getDisabledColumns().includes('productCode')">Product Id</ng-option>
                      <!-- <ng-option value="category" [disabled]="getDisabledColumns().includes('category')">Category</ng-option> -->
                      <ng-option value="txnId" [disabled]="getDisabledColumns().includes('txnId')">Order ID</ng-option>
                     <ng-option value="STATUS" [disabled]="getDisabledColumns().includes('status')">Status</ng-option>
                      <ng-option value="appVersion" [disabled]="getDisabledColumns().includes('appVersion')">App Version</ng-option>
                      <ng-option value="bankReferenceNumber" [disabled]="getDisabledColumns().includes('bankReferenceNumber')">Bank Reference Number</ng-option>
                      <ng-option value="deviceId" [disabled]="getDisabledColumns().includes('deviceId')">Device ID</ng-option>
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label class="col-form-label" for="logicalCondition1">Logical Condition</label>
                    <ng-select id="logicalCondition1" placeholder="Select Logical Condition"
                      [inputAttrs]="{maxlength: '100'}" [(ngModel)]="logicalCondition1" [disabled]="!columnnName1">
                      <ng-container *ngIf="columnnName1 === 'appVersion'">
                        <ng-option value="EqualsTo">Equals to</ng-option>
                        <ng-option value="NotEqualsTo">Not Equals to</ng-option>
                        <ng-option value="GreaterThanEqualTo">Greater than equal to</ng-option>
                        <ng-option value="LessThanEqualTo">Less than equal to</ng-option>
                        <ng-option value="GreaterThan">Greater than</ng-option>
                        <ng-option value="LessThan">Less than</ng-option>
                      </ng-container>
                      <ng-container *ngIf="columnnName1 !== 'appVersion'">
                        <ng-option value="EqualsTo">Equals to</ng-option>
                        <ng-option value="NotEqualsTo">Not Equals to</ng-option>
                      </ng-container>
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label class="col-form-label" for="searchText1">Search Text</label>
                    <input *ngIf="columnnName1 !== 'STATUS' && columnnName1 !== 'status'" type="text" class="form-control" id="searchText1" placeholder="Please enter search text"
                      [(ngModel)]="searchText1" [disabled]="!columnnName1"/>
                    <ng-select *ngIf="columnnName1 === 'STATUS' || columnnName1 === 'status'" id="searchText1" placeholder="Select Status"
                      [(ngModel)]="searchText1" [disabled]="!columnnName1">
                      <ng-option *ngFor="let status of statusFilterOptions" [value]="status.value">
                        {{status.label}}
                      </ng-option>
                    </ng-select>
                  </div>
                </div>

                <div class="row mt-4">
                  <div class="col-md-4">
                    <label class="col-form-label" for="columnName2">Column Name</label>
                    <ng-select id="columnName2" placeholder="Select Column Name" [inputAttrs]="{maxlength: '100'}"
                      [(ngModel)]="columnnName2" (ngModelChange)="onColumnNameChange2()">
                      <ng-option value="">Please select</ng-option>
                      <!-- <ng-option value="channel" [disabled]="getDisabledColumns().includes('channel')">Channel</ng-option> -->
                      <ng-option value="productCode" [disabled]="getDisabledColumns().includes('productCode')">Product Id</ng-option>
                      <!-- <ng-option value="category" [disabled]="getDisabledColumns().includes('category')">Category</ng-option> -->
                      <ng-option value="txnId" [disabled]="getDisabledColumns().includes('txnId')">Order ID</ng-option>
                      <ng-option value="STATUS" [disabled]="getDisabledColumns().includes('status')">Status</ng-option>
                      <ng-option value="appVersion" [disabled]="getDisabledColumns().includes('appVersion')">App Version</ng-option>
                      <ng-option value="bankReferenceNumber" [disabled]="getDisabledColumns().includes('bankReferenceNumber')">Bank Reference Number</ng-option>
                      <ng-option value="deviceId" [disabled]="getDisabledColumns().includes('deviceId')">Device ID</ng-option>
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label class="col-form-label" for="logicalCondition2">Logical Condition</label>
                    <ng-select id="logicalCondition2" placeholder="Select Logical Condition"
                      [inputAttrs]="{maxlength: '100'}" [(ngModel)]="logicalCondition2" [disabled]="!columnnName2">
                      <ng-container *ngIf="columnnName2 === 'appVersion'">
                        <ng-option value="EqualsTo">Equals to</ng-option>
                        <ng-option value="NotEqualsTo">Not Equals to</ng-option>
                        <ng-option value="GreaterThanEqualTo">Greater than equal to</ng-option>
                        <ng-option value="LessThanEqualTo">Less than equal to</ng-option>
                        <ng-option value="GreaterThan">Greater than</ng-option>
                        <ng-option value="LessThan">Less than</ng-option>
                      </ng-container>
                      <ng-container *ngIf="columnnName2 !== 'appVersion'">
                        <ng-option value="EqualsTo">Equals to</ng-option>
                        <ng-option value="NotEqualsTo">Not Equals to</ng-option>
                      </ng-container>
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label class="col-form-label" for="searchText2">Search Text</label>
                    <input *ngIf="columnnName2 !== 'STATUS' && columnnName2 !== 'status'" type="text" class="form-control" id="searchText2" placeholder="Please enter search text"
                      [(ngModel)]="searchText2" [disabled]="!columnnName2"/>
                    <ng-select *ngIf="columnnName2 === 'STATUS' || columnnName2 === 'status'" id="searchText2" placeholder="Select Status"
                      [(ngModel)]="searchText2" [disabled]="!columnnName2">
                      <ng-option *ngFor="let status of statusFilterOptions" [value]="status.value">
                        {{status.label}}
                      </ng-option>
                    </ng-select>
                  </div>
                </div>


                  <!-- Action Buttons -->
                  <div class="col-md-12 text-end mt-4">
                      <!-- <button class="btn bg-danger-custom" type="button" (click)="pageNumber=1;">
                          View
                      </button> -->
                  </div>
                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-xl-12">
          <div class="text-start" >

                    <button type="button" class="btn bg-danger-custom" (click)="onSearchFilter()"><i class="feather icon-search me-2"></i>Search</button>
                    <button (click)="resetFilter()" class="btn bg-secondary" type="button"><i class="feather icon-refresh-cw me-2"></i>Reset</button>

                    <button type="button" class="btn bg-danger-custom" *ngIf="permissions.includes('Search')" (click)="onExportCSV()"><i class="feather icon-download me-2"></i>Export Excel</button>
                    <button type="button" class="btn bg-danger-custom" *ngIf="permissions.includes('Search')" (click)="onBackgroundExport()"><i class="feather icon-download me-2"></i>Export All</button>

                        <div class="btn-group" ngbDropdown role="group">
                          <button class="btn bg-danger-custom" ngbDropdownToggle><i class="feather icon-columns me-2"></i>Columns</button>
                          <div ngbDropdownMenu class="ng-dropdown-panel-items p-1"
                            style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
                            <div class="form-group">
                              <!--            <label for="columns" class="form-label"> All Columns</label>-->
                              <div *ngIf="columnDefs" class="list-group ng-option">
                                <span *ngFor="let column of columnDefsCopy; let i = index" class="checkbox">
                                  <label class="list-group-item p-2">
                                    <input class="form-check-input me-1" type="checkbox" style="margin-left: 180px;" value="{{i}}" name="{{column.headerName}}"
                                      (change)="updateSelectedColumn($event)"
                                      [checked]="(tableSelectedColumn && (-1 !==tableSelectedColumn.indexOf(column)) ? 'checked': '')" />
                                    {{(column?.headerName?.replace('_','') || column?.field?.replace('_','') ) }}
                                  </label>
                                </span>
                              </div>

                            </div>

                          </div>


            </div>
            <br>

          </div>
        </div>
      </div>

      <div *ngIf="quickFilterShow" class="row" style="min-height: 100px">


          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">

                  <label class="col-form-label" for="searchMerName">Search by Legal Name</label>

                  <ng-select #filSearchMerName (keyup.enter)="onSearchBtnClick($event)" [(ngModel)]="searchMerName"
                    id="searchMerName" (keyup)="allowAlfanumeric($event)" (keypress)="OnlyCharacterAllowed($event)"
                    (change)="allowAlfanumeric($event)" placeholder="Search by Legal Name"
                    [inputAttrs]="{maxlength: '200'}" (focus)="fun('searchMerName')"
                    (focusout)="funover('searchMerName')">
                    <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.merchant_name">
                      {{merchant.merchant_name}}
                    </ng-option>
                  </ng-select>

                </div>
                <div class="col-md-4">
                  <!-- <div class="row"> -->
                  <label class="col-form-label" for="searchMID">Search by Merchant ID</label>
                  <!-- <div class="col-md-8"> -->

                  <!-- <input (keyup.enter)="onSearchBtnClick($event)" [(ngModel)]="searchMID" class="form-control"
                  id="searchMID" maxlength="10" (keyup)="allowAlfanumeric($event)" (change)="allowAlfanumeric($event)"
                  type="text" autocomplete="new-password" /> -->

                  <ng-select #filSearchMID [(ngModel)]="searchMID" id="searchMID" placeholder="Merchant Id"
                    [inputAttrs]="{maxlength: '100'}" (focus)="fun('searchMID')" (focusout)="funover('searchMID')">
                    <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.MerchantId">
                      {{merchant.merchant_name}} ({{merchant.MerchantId}})
                    </ng-option>
                  </ng-select>


                  <!-- <ng-select [items]="Resultdata" bindLabel="FieldValue" bindValue="FieldValue" [(ngModel)]="searchMID"
                  id="searchMID" placeholder="Merchant Id">
                  <ng-template ng-option-tmp let-item="item">
                    <div title="{{item.FieldValue}}">{{item.FieldValue}}</div>
                  </ng-template>
                </ng-select> -->
                  <!-- </div> -->
                  <!-- </div> -->
                </div>

                <div class="col-md-4">

                  <label class="col-form-label" for="resellerPartnerId">Reseller</label>

                  <!-- <ng-select [items]="resellerListOptions" bindLabel="FieldText" bindValue="FieldValue"
                  [(ngModel)]="resellerPartnerId" placeholder="Select Reseller Partner" required [inputAttrs]="{maxlength: '100'}">
                </ng-select> -->
                  <ng-select #filResellerPartnerId [(ngModel)]="resellerPartnerId" id="resellerPartnerId"
                    placeholder="Select Reseller Partner" [inputAttrs]="{maxlength: '100'}"
                    (focus)="fun('resellerPartnerId')" (focusout)="funover('resellerPartnerId')">
                    <ng-option *ngFor="let RESELLER of resellerListOptions" [value]="RESELLER.FieldValue">
                      {{RESELLER.FieldText}} ({{RESELLER.FieldValue}})
                    </ng-option>
                  </ng-select>

                </div>
              </div>


              <div class="row">
                <div class="col-md-4">

                  <label class="col-form-label" for="resellerPartnerId">Status</label>

                  <ng-select #filStatus [items]="merchantStatusdata" bindLabel="FieldText" bindValue="FieldValue"
                    [(ngModel)]="Status" placeholder="Select Status" required [inputAttrs]="{maxlength: '40'}" id="Status"
                    (focus)="fun('Status')" (focusout)="funover('Status')">
                  </ng-select>


                </div>



                <div class="col-md-4">
                  <div class="row">
                    <label class="col-form-label" for="searchMID">Search by Date Range </label>
                    <div class="col-md-6">
                      <input #filSearchFromDate [(ngModel)]="searchFromDate"
                      ngbDatepicker #d="ngbDatepicker" class="form-control" id="searchFromDate" placeholder="yyyy-mm-dd"
                      [maxDate]="maxDateFrom" (click)="d.toggle()"  />
                    </div>
                    <div class="col-md-6">
                      <input #filSearchToDate [(ngModel)]="searchToDate" class="form-control" id="searchToDate"
                      ngbDatepicker #d1="ngbDatepicker"  (click)="d1.toggle()" placeholder="yyyy-mm-dd"
                      [maxDate]="maxDate" [minDate]="minDate" />
                    </div>
                  </div>
                </div>

                <div class="col-sm-3 d-flex align-items-end">
                  <!-- <div class="row"> -->
                  <!-- <div class="col-md-12"> -->
                  <!-- <label class="col-form-label" for="searchMID">Search</label> -->
                  <!-- </div>            -->
                  <!-- <div class="col-md-6"> -->
                  <button (click)="onSearchBtnClick($event)" class="btn bg-danger-custom me-2" type="button" style="width: 100%;">
                    <i class="feather icon-search me-2"></i>Search
                  </button>
                  <button (click)="resetFilter()" class="btn btn-secondary" type="button" style="width: 100%;">
                    <i class="feather icon-refresh-cw me-2"></i>Reset
                  </button>
                  <!-- </div> -->
                  <!-- </div> -->
                </div>

              </div>


            </div>
          </div>

      </div>
      <div class="row mb-0" style="min-height: 470px">
        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
          <ag-grid-angular [enableCellTextSelection]=true (sortChanged)="onSortChange($event)"
            (filterChanged)="onFilterChange($event)" (filterModified)="onFilterModified($event)"
            (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
            (rowDoubleClicked)="onRowDoubleClicked($event)" (search)="globalSearch" [columnDefs]="tableSelectedColumn"
            [defaultColDef]="defaultColDef" [enableCellTextSelection]=true [paginationPageSize]="pageSize"
            [pagination]="true" [rowData]="rowData" [rowModelType]="" [rowSelection]="'single'"
            [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
          </ag-grid-angular>
        </div>
      </div>
      <div class="row mt-0">
        <div class="col-4 col-xs-4 d-flex">
          <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
            class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
            <!--          <option [ngValue]="10">10</option>-->
            <!--          <option [ngValue]="20">20</option>-->
            <!--          <option [ngValue]="30">30</option>-->
            <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
          </select>
          <p class="text-muted p-3"> Total Records: {{ collectionSize }}</p>
        </div>

        <div class="col-8 col-xs-8">
          <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
            [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="false" [directionLinks]="true"
            [ellipses]="false" size="sm" class="d-flex justify-content-end align-right">
          </ngb-pagination>
        </div>

      </div>
    </div>

  </div>

  <app-modal #modalTopupAction [modalConfig]="modalConfigBlocked">
  <app-topup-action
    (closeModal)="closeModalTopup($event)"
    [merchantStatusConfig]="tableInfo"
    [onMerchantMId]="TopupActionSelectEvent">
  </app-topup-action>
</app-modal>




